import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import axiosInstance from '../utils/axios'; 
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/Contact.css";

function ContactPage() {
  const [status, setStatus] = useState(null);
  
  const [consoleError, setConsoleError] = useState("");
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axiosInstance.post("contact/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setStatus(res.data.message);
      setFormData({ name: "", email: "", subject: "", message: "" });
      if (setlang === "en") {
        setStatus("Thank you for your message.");
      } else {
        setStatus("سپاس از پیامتون، با شما در تماس خواهیم بود");
      }
      
    } catch (err) {
      if (setlang === "en") {
        setStatus("Failed to send message. Please try again.");
      } else {
        setStatus("در ارسال پیام مشکلی رخ داد، لطفا دوباره تلا‍ش کنید");
      }
      setConsoleError(err);
    }
  };

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  return (
    <>
      <NavbarLog />
      <div className="contact-page">
        
        {setlang === "en" ? 
        <h2>Contact Us</h2> : <h2>تماس با ما</h2>
        }

        {status && <p>{status}</p>}
        <div className="form-wrapper">
          <form onSubmit={handleSubmit}>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={setlang === "en" ? "Name" : "نام"}
              required
            /><br />
            <input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={setlang === "en" ? "Email" : "ایمیل"}
              required
            /><br />
            <input
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder={setlang === "en" ? "Subject" : "موضوع"}
              required
            /><br />
            <textarea
              style={{
                width: "100%", 
                height: "150px", 
                padding: "10px", 
                resize: "vertical",   
                overflow: "auto", 
              }}
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={setlang === "en" ? "Message" : "پیام"}
              required
            /><br />
            <button type="submit">{setlang === "en" ? "Send" : "ارسال"}</button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ContactPage;
